import { UNRATED_GROUP_MEETING_RATING } from "meetings/group-meeting/constants";
import {
  groupMeetingRatingTypeFromDto,
  groupMeetingStudentFromDto,
} from "meetings/group-meeting/api/mappers/groupMeeting.mapper";
import type {
  TeacherGroupMeeting,
  TeacherGroupMeetingDto,
  TeacherGroupMeetingMentorClass,
  TeacherGroupMeetingMentorClassDto,
  TeacherGroupMeetingRating,
  TeacherGroupMeetingRatingDto,
} from "meetings/group-meeting/types";
import { toDate } from "shared/mappers";

/**
 * The backend stores "not rated" as the sentinel 5
 * (MEETING-RATING-COMPLETION-001); the domain represents it as null so the
 * shared rating rows and progress counts treat 1–4 as the only real ratings.
 */
const teacherGroupMeetingRatingValueFromDto = (
  rating: number | null,
): number | null =>
  rating === null || rating === UNRATED_GROUP_MEETING_RATING ? null : rating;

export const teacherGroupMeetingRatingFromDto = (
  dto: TeacherGroupMeetingRatingDto,
): TeacherGroupMeetingRating => ({
  id: Number(dto.id),
  ratingTypeId: Number(dto.rating_type_id),
  rating: teacherGroupMeetingRatingValueFromDto(dto.rating),
  ratingRemark: dto.rating_remark ?? null,
});

export const teacherGroupMeetingMentorClassFromDto = (
  dto: TeacherGroupMeetingMentorClassDto,
): TeacherGroupMeetingMentorClass => ({
  name: dto.name,
  percentage: Math.min(Number(dto.percentage ?? 0), 100),
  mentors: dto.mentors,
  students: dto.students.map(groupMeetingStudentFromDto),
  ratings: dto.ratings.map(teacherGroupMeetingRatingFromDto),
});

export const teacherGroupMeetingFromDto = (
  dto: TeacherGroupMeetingDto,
): TeacherGroupMeeting => ({
  id: Number(dto.id),
  schoolId: Number(dto.school_id),
  status: dto.status,
  name: dto.name,
  message: dto.message ?? null,
  ratingTypes: dto.rating_types.map(groupMeetingRatingTypeFromDto),
  mentorClasses: dto.mentor_classes.map(teacherGroupMeetingMentorClassFromDto),
  timeframe: dto.timeframe_settings
    ? {
        opensAt: toDate(dto.timeframe_settings.open_at),
        closedNoModifyAt: toDate(dto.timeframe_settings.closed_no_modify_at),
        archivedAt: toDate(dto.timeframe_settings.archived_at),
      }
    : null,
});
